export const FETCH_CATALOG = 'catalog/FETCH'
export const FETCH_CATALOG_SUCCESS = `${FETCH_CATALOG}_SUCCESS`
export const FETCH_CATALOG_FAIL = `${FETCH_CATALOG}_FAIL`

const initialState = {
  isLoading: false,
  isLoaded: false,
  currencyConfiguration: { pointsName: '', decimalPlaces: 0 },
  redeemType: ''
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG:
      return { ...state, isLoading: true }
    case FETCH_CATALOG_SUCCESS:
      return { ...state, ...action.payload.data, isLoading: false, isLoaded: true }
    case FETCH_CATALOG_FAIL:
      return { isLoaded: false, ...state, isLoading: false }
    default: return state
  }
}

export const fetchCatalog = () => ({
  type: FETCH_CATALOG,
  payload: {
    client: 'cloudloyalty',
    request: {
      url: `/v1/configurations/catalogs/byToken`
    }
  }
})

export const isRedeemPointsMoreOthers = type => type === 'POINTSMOREOTHERS'



// WEBPACK FOOTER //
// ./src/Catalog/ducks.js